import { render } from "./CatalogProductView.vue?vue&type=template&id=ebed628c&scoped=true"
import script from "./CatalogProductView.vue?vue&type=script&lang=js"
export * from "./CatalogProductView.vue?vue&type=script&lang=js"

import "./CatalogProductView.vue?vue&type=style&index=0&id=ebed628c&scoped=true&lang=css"
import "./CatalogProductView.vue?vue&type=style&index=1&id=ebed628c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebed628c"]])

export default __exports__